import { TableComponent } from './Table';
import { TableProvider } from './Provider';
export * from './utils/cells';

export const Table = TableComponent;
export { TableProvider };
